import React from 'react';

const WinLossAnalysisContent = ({ 
  analysisSubTab, 
  winAnalysis, 
  lossAnalysis, 
  comparisonStats,
  loadingWinAnalysis,
  loadingLossAnalysis,
  loadingComparisonStats
}) => {

  // WINS TAB
  if (analysisSubTab === 'wins') {
    if (loadingWinAnalysis) {
      return (
        <div style={{ textAlign: 'center', padding: '3rem', color: '#64748b' }}>
          <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>⏳</div>
          <div style={{ fontSize: '1.125rem' }}>Analyzing your wins...</div>
        </div>
      );
    }

    if (!winAnalysis || !winAnalysis.winning_trades || winAnalysis.winning_trades.length === 0) {
      return (
        <div style={{ textAlign: 'center', padding: '3rem', color: '#64748b' }}>
          <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>📊</div>
          <div style={{ fontSize: '1.125rem', marginBottom: '0.5rem' }}>No winning trades yet</div>
          <div style={{ fontSize: '0.875rem' }}>Keep trading! Your wins will appear here.</div>
        </div>
      );
    }

    const avgProfit = (winAnalysis.winning_trades.reduce((sum, t) => sum + (t.actual_profit || 0), 0) / winAnalysis.winning_trades.length).toFixed(2);
    const avgTpReached = (winAnalysis.winning_trades.reduce((sum, t) => sum + (t.highest_profit_reached || 0), 0) / winAnalysis.winning_trades.length).toFixed(1);

    return (
      <div>
        {/* Summary Stats */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '1.5rem', marginBottom: '2rem' }}>
          <div style={{ background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)', padding: '1.5rem', borderRadius: '12px', color: 'white' }}>
            <div style={{ fontSize: '0.875rem', opacity: 0.9, marginBottom: '0.5rem' }}>Total Wins Analyzed</div>
            <div style={{ fontSize: '2rem', fontWeight: '700' }}>{winAnalysis.winning_trades.length}</div>
          </div>
          <div style={{ background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)', padding: '1.5rem', borderRadius: '12px', color: 'white' }}>
            <div style={{ fontSize: '0.875rem', opacity: 0.9, marginBottom: '0.5rem' }}>Avg Profit Per Win</div>
            <div style={{ fontSize: '2rem', fontWeight: '700' }}>${avgProfit}</div>
          </div>
          <div style={{ background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)', padding: '1.5rem', borderRadius: '12px', color: 'white' }}>
            <div style={{ fontSize: '0.875rem', opacity: 0.9, marginBottom: '0.5rem' }}>Avg % of TP Reached</div>
            <div style={{ fontSize: '2rem', fontWeight: '700' }}>{avgTpReached}%</div>
          </div>
        </div>

        {/* Key Insights for Wins */}
        {winAnalysis.key_insights && winAnalysis.key_insights.length > 0 && (
          <div style={{ marginBottom: '2rem', padding: '1.5rem', background: 'linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%)', borderRadius: '12px', border: '2px solid #86efac' }}>
            <h3 style={{ fontSize: '1.25rem', color: '#166534', marginBottom: '1rem', fontWeight: '700' }}>
              💡 Key Insights
            </h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
              {winAnalysis.key_insights.map((insight, idx) => (
                <div key={idx} style={{ background: 'white', padding: '1rem', borderRadius: '8px', border: '1px solid #86efac' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
                    <span style={{ fontSize: '1.5rem' }}>{insight.icon}</span>
                    <span style={{ fontWeight: '700', color: '#166534' }}>{insight.title}</span>
                  </div>
                  <div style={{ fontSize: '0.875rem', color: '#15803d', lineHeight: '1.5' }}>{insight.detail}</div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Wins List */}
        <div style={{ background: '#f8fafc', padding: '1.5rem', borderRadius: '12px' }}>
          <h3 style={{ fontSize: '1.25rem', color: '#0c4a6e', marginBottom: '1rem', fontWeight: '700' }}>
            ✅ All Wins ({winAnalysis.total_wins || winAnalysis.winning_trades.length} trades)
          </h3>
          <div style={{ marginBottom: '1rem', padding: '0.75rem', background: '#dcfce7', borderRadius: '6px', fontSize: '0.875rem', color: '#166534' }}>
            <strong>Legend:</strong> {winAnalysis.note}
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            {winAnalysis.winning_trades.map((win, idx) => (
              <div
                key={idx}
                style={{
                  background: 'white',
                  padding: '1.25rem',
                  borderRadius: '8px',
                  border: '2px solid #d1fae5',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                }}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '0.75rem' }}>
                  <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                    <span style={{ fontSize: '1.5rem', fontWeight: '700', color: '#10b981' }}>#{idx + 1}</span>
                    <div>
                      <div style={{ fontSize: '1.125rem', fontWeight: '700', color: '#0f172a' }}>
                        {win.pair} {win.direction}
                      </div>
                      <div style={{ fontSize: '0.875rem', color: '#64748b', marginTop: '0.25rem' }}>
                        {win.outcome_time ? new Date(win.outcome_time).toLocaleDateString() + ' at ' + new Date(win.outcome_time).toLocaleTimeString() : 'N/A'}
                      </div>
                    </div>
                  </div>
                  <div style={{
                    padding: '0.5rem 1rem',
                    background: win.probability >= 90 ? '#dcfce7' : win.probability >= 80 ? '#fef3c7' : '#f1f5f9',
                    color: win.probability >= 90 ? '#166534' : win.probability >= 80 ? '#92400e' : '#64748b',
                    borderRadius: '6px',
                    fontWeight: '700',
                    fontSize: '0.875rem'
                  }}>
                    {win.probability}% Probability
                  </div>
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem' }}>
                  <div>
                    <div style={{ fontSize: '0.75rem', color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '0.25rem' }}>
                      TP Progress Reached
                    </div>
                    <div style={{ fontSize: '1.25rem', fontWeight: '700', color: win.highest_profit_reached >= 95 ? '#10b981' : win.highest_profit_reached >= 70 ? '#3b82f6' : '#f59e0b' }}>
                      {win.highest_profit_reached?.toFixed(1)}%
                    </div>
                  </div>
                  <div>
                    <div style={{ fontSize: '0.75rem', color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '0.25rem' }}>
                      Actual Profit
                    </div>
                    <div style={{ fontSize: '1.25rem', fontWeight: '700', color: '#10b981' }}>
                      +${win.actual_profit?.toFixed(2)}
                    </div>
                  </div>
                  <div style={{ gridColumn: 'span 2' }}>
                    <div style={{ fontSize: '0.75rem', color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '0.25rem' }}>
                      Exit Classification
                    </div>
                    <div style={{
                      fontSize: '1rem',
                      fontWeight: '700',
                      color: 'white',
                      background: win.classification === 'FULL_TP' ? '#10b981' : win.classification === 'NEAR_TP' ? '#3b82f6' : win.classification === 'PARTIAL_TP' ? '#f59e0b' : '#64748b',
                      padding: '0.5rem 1rem',
                      borderRadius: '6px',
                      display: 'inline-block'
                    }}>
                      {win.classification === 'FULL_TP' && '🎯 FULL TP (95%+)'}
                      {win.classification === 'NEAR_TP' && '✅ NEAR TP (70-95%)'}
                      {win.classification === 'PARTIAL_TP' && '⚠️ PARTIAL TP (50-70%)'}
                      {win.classification === 'EARLY_EXIT' && '⏭️ EARLY EXIT (<50%)'}
                    </div>
                  </div>
                </div>

                {/* Win Analysis */}
                <div style={{ marginTop: '1rem', padding: '1rem', background: '#f0fdf4', borderRadius: '6px', fontSize: '0.875rem', color: '#166534' }}>
                  {win.classification === 'FULL_TP' ? (
                    <>
                      <strong>Excellent!</strong> This trade reached your full take profit target ({win.highest_profit_reached?.toFixed(1)}% of TP). 
                      Keep executing trades like this!
                    </>
                  ) : win.classification === 'NEAR_TP' ? (
                    <>
                      <strong>Great execution!</strong> Trade reached {win.highest_profit_reached?.toFixed(1)}% of TP before closing. 
                      Very close to full target - consider letting winners run a bit longer.
                    </>
                  ) : win.classification === 'PARTIAL_TP' ? (
                    <>
                      <strong>Good profit secured.</strong> Trade reached {win.highest_profit_reached?.toFixed(1)}% of TP. 
                      While profitable, this closed early. Consider trailing stops to capture more upside.
                    </>
                  ) : (
                    <>
                      <strong>Early exit.</strong> Trade closed at {win.highest_profit_reached?.toFixed(1)}% of TP. 
                      While still profitable, this may indicate taking profits too quickly or tight trailing stops.
                    </>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  // LOSSES TAB (existing content, keeping it as is)
  if (analysisSubTab === 'losses') {
    if (loadingLossAnalysis) {
      return (
        <div style={{ textAlign: 'center', padding: '3rem', color: '#64748b' }}>
          <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>⏳</div>
          <div style={{ fontSize: '1.125rem' }}>Analyzing your losses...</div>
        </div>
      );
    }

    if (!lossAnalysis || !lossAnalysis.losing_trades || lossAnalysis.losing_trades.length === 0) {
      return (
        <div style={{ textAlign: 'center', padding: '3rem', color: '#64748b' }}>
          <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🎉</div>
          <div style={{ fontSize: '1.125rem', marginBottom: '0.5rem' }}>No losses to analyze</div>
          <div style={{ fontSize: '0.875rem' }}>Great job! Keep up the good work.</div>
        </div>
      );
    }

    const avgLossProfit = (lossAnalysis.losing_trades.reduce((sum, t) => sum + (t.highest_profit_reached || 0), 0) / lossAnalysis.losing_trades.length).toFixed(1);
    const wrongDirection = lossAnalysis.losing_trades.filter(t => t.classification === 'WRONG_DIRECTION').length;
    const poorEntry = lossAnalysis.losing_trades.filter(t => t.classification === 'POOR_ENTRY').length;
    const tightSL = lossAnalysis.losing_trades.filter(t => t.classification === 'TIGHT_SL').length;

    return (
      <div>
        {/* Summary Stats */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '1.5rem', marginBottom: '2rem' }}>
          <div style={{ background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)', padding: '1.5rem', borderRadius: '12px', color: 'white' }}>
            <div style={{ fontSize: '0.875rem', opacity: 0.9, marginBottom: '0.5rem' }}>Total Losses Analyzed</div>
            <div style={{ fontSize: '2rem', fontWeight: '700' }}>{lossAnalysis.total_losses || lossAnalysis.losing_trades.length}</div>
          </div>
          <div style={{ background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)', padding: '1.5rem', borderRadius: '12px', color: 'white' }}>
            <div style={{ fontSize: '0.875rem', opacity: 0.9, marginBottom: '0.5rem' }}>Avg Profit Reached</div>
            <div style={{ fontSize: '2rem', fontWeight: '700' }}>{avgLossProfit}%</div>
          </div>
          <div style={{ background: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)', padding: '1.5rem', borderRadius: '12px', color: 'white' }}>
            <div style={{ fontSize: '0.875rem', opacity: 0.9, marginBottom: '0.5rem' }}>Issue Breakdown</div>
            <div style={{ fontSize: '0.875rem', fontWeight: '600' }}>
              {wrongDirection} Wrong Dir | {poorEntry} Poor Entry | {tightSL} Tight SL
            </div>
          </div>
        </div>

        {/* KEY INSIGHTS - Detailed Pattern Analysis */}
        {lossAnalysis.key_insights && lossAnalysis.key_insights.length > 0 && (
          <div style={{ marginBottom: '2rem', padding: '1.5rem', background: 'linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%)', borderRadius: '12px', border: '2px solid #fca5a5' }}>
            <h3 style={{ fontSize: '1.25rem', color: '#b91c1c', marginBottom: '1rem', fontWeight: '700' }}>
              🔍 Key Insights - Why You Lost
            </h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
              {lossAnalysis.key_insights.map((insight, idx) => (
                <div 
                  key={idx} 
                  style={{ 
                    background: 'white', 
                    padding: '1rem', 
                    borderRadius: '8px', 
                    border: insight.severity === 'HIGH' ? '2px solid #ef4444' : insight.severity === 'MEDIUM' ? '2px solid #f59e0b' : '1px solid #e5e7eb'
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
                    <span style={{ fontSize: '1.5rem' }}>{insight.icon}</span>
                    <span style={{ fontWeight: '700', color: insight.severity === 'HIGH' ? '#b91c1c' : insight.severity === 'MEDIUM' ? '#d97706' : '#374151' }}>
                      {insight.title}
                    </span>
                    <span style={{ 
                      fontSize: '0.75rem', 
                      padding: '0.25rem 0.5rem', 
                      borderRadius: '4px',
                      background: insight.severity === 'HIGH' ? '#fef2f2' : insight.severity === 'MEDIUM' ? '#fef3c7' : '#f3f4f6',
                      color: insight.severity === 'HIGH' ? '#b91c1c' : insight.severity === 'MEDIUM' ? '#d97706' : '#6b7280',
                      fontWeight: '600'
                    }}>
                      {insight.severity}
                    </span>
                  </div>
                  <div style={{ fontSize: '0.875rem', color: '#374151', lineHeight: '1.6' }}>{insight.detail}</div>
                  {insight.recommendation && (
                    <div style={{ marginTop: '0.75rem', padding: '0.75rem', background: '#fef3c7', borderRadius: '6px', fontSize: '0.875rem', color: '#92400e' }}>
                      <strong>💡 Recommendation:</strong> {insight.recommendation}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Losses List */}
        <div style={{ background: '#f8fafc', padding: '1.5rem', borderRadius: '12px', marginBottom: '2rem' }}>
          <h3 style={{ fontSize: '1.25rem', color: '#0c4a6e', marginBottom: '1rem', fontWeight: '700' }}>
            📋 All Losses ({lossAnalysis.total_losses || lossAnalysis.losing_trades.length} trades)
          </h3>
          <div style={{ marginBottom: '1rem', padding: '0.75rem', background: '#fef3c7', borderRadius: '6px', fontSize: '0.875rem', color: '#92400e' }}>
            <strong>Legend:</strong> {lossAnalysis.note}
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            {lossAnalysis.losing_trades.map((loss, idx) => (
              <div
                key={idx}
                style={{
                  background: 'white',
                  padding: '1.25rem',
                  borderRadius: '8px',
                  border: loss.severity === 'HIGH' ? '3px solid #ef4444' : loss.severity === 'MEDIUM' ? '2px solid #f59e0b' : '2px solid #fee2e2',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                }}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '0.75rem' }}>
                  <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                    <span style={{ fontSize: '1.5rem', fontWeight: '700', color: '#ef4444' }}>#{idx + 1}</span>
                    <div>
                      <div style={{ fontSize: '1.125rem', fontWeight: '700', color: '#0f172a' }}>
                        {loss.pair} {loss.direction}
                      </div>
                      <div style={{ fontSize: '0.875rem', color: '#64748b', marginTop: '0.25rem' }}>
                        {loss.outcome_time ? new Date(loss.outcome_time).toLocaleDateString() + ' at ' + new Date(loss.outcome_time).toLocaleTimeString() : 'N/A'}
                      </div>
                    </div>
                  </div>
                  <div style={{
                    padding: '0.5rem 1rem',
                    background: loss.probability >= 90 ? '#fee2e2' : loss.probability >= 80 ? '#fef3c7' : '#f1f5f9',
                    color: loss.probability >= 90 ? '#dc2626' : loss.probability >= 80 ? '#d97706' : '#64748b',
                    borderRadius: '6px',
                    fontWeight: '700',
                    fontSize: '0.875rem'
                  }}>
                    {loss.probability}% Probability
                  </div>
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem' }}>
                  <div>
                    <div style={{ fontSize: '0.75rem', color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '0.25rem' }}>
                      Max Profit Reached
                    </div>
                    <div style={{ fontSize: '1.25rem', fontWeight: '700', color: loss.highest_profit_reached >= 10 ? '#f59e0b' : '#ef4444' }}>
                      {loss.highest_profit_reached?.toFixed(1)}%
                    </div>
                  </div>
                  <div style={{ gridColumn: 'span 2' }}>
                    <div style={{ fontSize: '0.75rem', color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '0.25rem' }}>
                      Diagnosed Issue
                    </div>
                    <div style={{
                      fontSize: '1rem',
                      fontWeight: '700',
                      color: 'white',
                      background: loss.classification === 'WRONG_DIRECTION' ? '#ef4444' : loss.classification === 'POOR_ENTRY' ? '#f59e0b' : loss.classification === 'TIGHT_SL' ? '#10b981' : '#64748b',
                      padding: '0.5rem 1rem',
                      borderRadius: '6px',
                      display: 'inline-block'
                    }}>
                      {loss.classification === 'WRONG_DIRECTION' && '❌ WRONG DIRECTION'}
                      {loss.classification === 'POOR_ENTRY' && '⚠️ POOR ENTRY (Got Close)'}
                      {loss.classification === 'TIGHT_SL' && '🎯 TIGHT SL (Reached 40%+)'}
                      {loss.classification === 'UNKNOWN' && '🔍 Unknown Issue'}
                    </div>
                  </div>
                </div>

                <div style={{ marginTop: '1rem', padding: '1rem', background: '#fef2f2', borderRadius: '6px', fontSize: '0.875rem', color: '#991b1b' }}>
                  {loss.detailed_reason ? (
                    <>
                      <strong>Analysis:</strong> {loss.detailed_reason}
                    </>
                  ) : loss.classification === 'WRONG_DIRECTION' ? (
                    <>
                      <strong>Analysis:</strong> Price never moved favorably. The market immediately went against your position, 
                      reaching only {loss.highest_profit_reached?.toFixed(1)}% toward target. This indicates the market direction was incorrect.
                    </>
                  ) : loss.classification === 'POOR_ENTRY' ? (
                    <>
                      <strong>Analysis:</strong> Price reached {loss.highest_profit_reached?.toFixed(1)}% toward your take profit (10-40%), 
                      showing the direction was correct, but the entry timing or level was suboptimal. Consider waiting for better 
                      confirmation or adjusting entry strategy.
                    </>
                  ) : loss.classification === 'TIGHT_SL' ? (
                    <>
                      <strong>Analysis:</strong> Price reached {loss.highest_profit_reached?.toFixed(1)}% toward your take profit (40%+)! 
                      This was very close to succeeding. Consider using trailing stop-losses or widening your SL to give trades more room.
                    </>
                  ) : (
                    <>
                      <strong>Analysis:</strong> Unable to determine specific cause. Review market conditions during this trade.
                    </>
                  )}
                </div>

                {/* Acceptance Reasons - Why was this trade accepted? */}
                {loss.acceptance_reasons && loss.acceptance_reasons.length > 0 && (
                  <div style={{ marginTop: '1rem', padding: '1rem', background: '#f0f9ff', borderRadius: '6px', border: '1px solid #bae6fd' }}>
                    <div style={{ fontSize: '0.75rem', color: '#0369a1', fontWeight: '700', marginBottom: '0.5rem', textTransform: 'uppercase' }}>
                      📋 Why This Trade Was Accepted:
                    </div>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
                      {loss.acceptance_reasons.map((reason, i) => (
                        <span key={i} style={{ 
                          fontSize: '0.75rem', 
                          padding: '0.25rem 0.5rem', 
                          background: '#e0f2fe', 
                          borderRadius: '4px',
                          color: '#0c4a6e'
                        }}>
                          {reason}
                        </span>
                      ))}
                    </div>
                  </div>
                )}

                {/* Full Indicator Details - What the system detected */}
                {loss.indicator_details && (
                  <div style={{ marginTop: '1rem', padding: '1rem', background: '#f5f3ff', borderRadius: '6px', border: '1px solid #c4b5fd' }}>
                    <div style={{ fontSize: '0.75rem', color: '#5b21b6', fontWeight: '700', marginBottom: '0.75rem', textTransform: 'uppercase' }}>
                      🔬 Full Indicator Analysis at Entry:
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '0.75rem' }}>
                      
                      {/* Market Regime */}
                      {loss.indicator_details.market_regime && (
                        <div style={{ background: 'white', padding: '0.75rem', borderRadius: '6px', border: '1px solid #ddd6fe' }}>
                          <div style={{ fontSize: '0.7rem', color: '#7c3aed', fontWeight: '700', marginBottom: '0.5rem' }}>📊 MARKET REGIME</div>
                          <div style={{ fontSize: '0.875rem', fontWeight: '600', color: '#1f2937' }}>
                            {loss.indicator_details.market_regime.regime}
                          </div>
                          <div style={{ fontSize: '0.75rem', color: '#6b7280' }}>
                            Confidence: {loss.indicator_details.market_regime.confidence?.toFixed(0)}%
                          </div>
                          <div style={{ fontSize: '0.75rem', color: '#6b7280' }}>
                            Trend: {loss.indicator_details.market_regime.trend_direction} ({loss.indicator_details.market_regime.trend_strength?.toFixed(0)}%)
                          </div>
                          <div style={{ fontSize: '0.75rem', color: loss.indicator_details.market_regime.probability_adjustment >= 0 ? '#059669' : '#dc2626' }}>
                            Adjustment: {loss.indicator_details.market_regime.probability_adjustment > 0 ? '+' : ''}{loss.indicator_details.market_regime.probability_adjustment?.toFixed(0)}%
                          </div>
                        </div>
                      )}
                      
                      {/* Smart Money */}
                      {loss.indicator_details.smart_money && (
                        <div style={{ background: 'white', padding: '0.75rem', borderRadius: '6px', border: '1px solid #ddd6fe' }}>
                          <div style={{ fontSize: '0.7rem', color: '#7c3aed', fontWeight: '700', marginBottom: '0.5rem' }}>💰 SMART MONEY</div>
                          <div style={{ fontSize: '0.875rem', fontWeight: '600', color: loss.indicator_details.smart_money.bias === 'BULLISH' ? '#059669' : loss.indicator_details.smart_money.bias === 'BEARISH' ? '#dc2626' : '#6b7280' }}>
                            {loss.indicator_details.smart_money.bias}
                          </div>
                          <div style={{ fontSize: '0.75rem', color: '#6b7280' }}>
                            Confidence: {loss.indicator_details.smart_money.confidence?.toFixed(0)}%
                          </div>
                          <div style={{ fontSize: '0.75rem', color: loss.indicator_details.smart_money.probability_adjustment >= 0 ? '#059669' : '#dc2626' }}>
                            Adjustment: {loss.indicator_details.smart_money.probability_adjustment > 0 ? '+' : ''}{loss.indicator_details.smart_money.probability_adjustment?.toFixed(0)}%
                          </div>
                        </div>
                      )}
                      
                      {/* Multi-Timeframe */}
                      {loss.indicator_details.multi_timeframe && (
                        <div style={{ background: 'white', padding: '0.75rem', borderRadius: '6px', border: '1px solid #ddd6fe' }}>
                          <div style={{ fontSize: '0.7rem', color: '#7c3aed', fontWeight: '700', marginBottom: '0.5rem' }}>⏱️ TIMEFRAME ALIGNMENT</div>
                          <div style={{ fontSize: '0.875rem', fontWeight: '600', color: '#1f2937' }}>
                            {loss.indicator_details.multi_timeframe.aligned_timeframes}/{loss.indicator_details.multi_timeframe.total_timeframes} Aligned
                          </div>
                          <div style={{ fontSize: '0.75rem', color: '#6b7280' }}>
                            Alignment: {loss.indicator_details.multi_timeframe.alignment_percentage?.toFixed(0)}%
                          </div>
                          <div style={{ fontSize: '0.75rem', color: loss.indicator_details.multi_timeframe.adjustment >= 0 ? '#059669' : '#dc2626' }}>
                            Adjustment: {loss.indicator_details.multi_timeframe.adjustment > 0 ? '+' : ''}{loss.indicator_details.multi_timeframe.adjustment?.toFixed(0)}%
                          </div>
                        </div>
                      )}
                      
                      {/* Currency Strength */}
                      {loss.indicator_details.currency_strength && (
                        <div style={{ background: 'white', padding: '0.75rem', borderRadius: '6px', border: '1px solid #ddd6fe' }}>
                          <div style={{ fontSize: '0.7rem', color: '#7c3aed', fontWeight: '700', marginBottom: '0.5rem' }}>💪 CURRENCY STRENGTH</div>
                          <div style={{ fontSize: '0.875rem', fontWeight: '600', color: loss.indicator_details.currency_strength.alignment === 'STRONG_ALIGNMENT' ? '#059669' : loss.indicator_details.currency_strength.alignment?.includes('MISALIGNED') ? '#dc2626' : '#6b7280' }}>
                            {loss.indicator_details.currency_strength.alignment}
                          </div>
                          <div style={{ fontSize: '0.75rem', color: '#6b7280' }}>
                            {loss.indicator_details.currency_strength.base_currency}: {loss.indicator_details.currency_strength.base_score > 0 ? '+' : ''}{loss.indicator_details.currency_strength.base_score?.toFixed(0)}
                          </div>
                          <div style={{ fontSize: '0.75rem', color: '#6b7280' }}>
                            {loss.indicator_details.currency_strength.quote_currency}: {loss.indicator_details.currency_strength.quote_score > 0 ? '+' : ''}{loss.indicator_details.currency_strength.quote_score?.toFixed(0)}
                          </div>
                        </div>
                      )}
                      
                      {/* Session & Volatility */}
                      {loss.indicator_details.session_volatility && (
                        <div style={{ background: 'white', padding: '0.75rem', borderRadius: '6px', border: '1px solid #ddd6fe' }}>
                          <div style={{ fontSize: '0.7rem', color: '#7c3aed', fontWeight: '700', marginBottom: '0.5rem' }}>🌍 SESSION & VOLATILITY</div>
                          <div style={{ fontSize: '0.875rem', fontWeight: '600', color: '#1f2937' }}>
                            {loss.indicator_details.session_volatility.session} ({loss.indicator_details.session_volatility.session_quality})
                          </div>
                          <div style={{ fontSize: '0.75rem', color: loss.indicator_details.session_volatility.volatility_state === 'ELEVATED' ? '#d97706' : '#6b7280' }}>
                            Volatility: {loss.indicator_details.session_volatility.volatility_state}
                          </div>
                          <div style={{ fontSize: '0.75rem', color: loss.indicator_details.session_volatility.news_risk ? '#dc2626' : '#059669' }}>
                            News Risk: {loss.indicator_details.session_volatility.news_risk ? 'YES' : 'No'}
                          </div>
                        </div>
                      )}
                      
                    </div>
                  </div>
                )}

                {/* Potential Causes - What caused this loss? */}
                {loss.potential_causes && loss.potential_causes.length > 0 && (
                  <div style={{ marginTop: '0.75rem', padding: '1rem', background: '#fef3c7', borderRadius: '6px', border: '1px solid #fcd34d' }}>
                    <div style={{ fontSize: '0.75rem', color: '#92400e', fontWeight: '700', marginBottom: '0.5rem', textTransform: 'uppercase' }}>
                      ⚠️ Potential Causes:
                    </div>
                    <ul style={{ margin: 0, paddingLeft: '1.25rem', color: '#78350f', fontSize: '0.875rem' }}>
                      {loss.potential_causes.map((cause, i) => (
                        <li key={i} style={{ marginBottom: '0.25rem' }}>{cause}</li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Key Insights */}
        <div style={{ background: 'linear-gradient(135deg, #1e40af 0%, #1e3a8a 100%)', padding: '1.5rem', borderRadius: '12px', color: 'white' }}>
          <h3 style={{ fontSize: '1.25rem', marginBottom: '1rem', fontWeight: '700' }}>💡 Key Insights</h3>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
            <li style={{ marginBottom: '0.75rem', display: 'flex', alignItems: 'start', gap: '0.75rem' }}>
              <span style={{ fontSize: '1.25rem' }}>📊</span>
              <span>
                You have {wrongDirection} losses from wrong direction, {poorEntry} from poor entry timing, and {tightSL} from tight stop-loss.
              </span>
            </li>
            <li style={{ marginBottom: '0.75rem', display: 'flex', alignItems: 'start', gap: '0.75rem' }}>
              <span style={{ fontSize: '1.25rem' }}>🎯</span>
              <span>
                Average profit reached before reversal: {avgLossProfit}%. 
                Losses that got close to TP (10%+) indicate correct analysis but poor execution.
              </span>
            </li>
            <li style={{ display: 'flex', alignItems: 'start', gap: '0.75rem' }}>
              <span style={{ fontSize: '1.25rem' }}>💪</span>
              <span>
                Consider implementing trailing stop-losses or partial profit-taking for trades that reach 15-20% toward TP to lock in gains.
              </span>
            </li>
          </ul>
        </div>
      </div>
    );
  }

  // COMPARISON TAB
  if (analysisSubTab === 'comparison') {
    if (loadingComparisonStats) {
      return (
        <div style={{ textAlign: 'center', padding: '3rem', color: '#64748b' }}>
          <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>⏳</div>
          <div style={{ fontSize: '1.125rem' }}>Calculating comparison stats...</div>
        </div>
      );
    }

    if (!comparisonStats || !comparisonStats.overview) {
      return (
        <div style={{ textAlign: 'center', padding: '3rem', color: '#64748b' }}>
          <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>📊</div>
          <div style={{ fontSize: '1.125rem', marginBottom: '0.5rem' }}>No comparison data available</div>
          <div style={{ fontSize: '0.875rem' }}>Complete more trades to see comparisons</div>
        </div>
      );
    }

    const overview = comparisonStats.overview;

    return (
      <div>
        {/* Overall Performance */}
        <div style={{ background: 'linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)', padding: '2rem', borderRadius: '12px', marginBottom: '2rem', color: 'white' }}>
          <h3 style={{ fontSize: '1.5rem', marginBottom: '1.5rem', fontWeight: '700' }}>📊 Overall Performance</h3>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1.5rem' }}>
            <div>
              <div style={{ fontSize: '0.875rem', opacity: 0.9, marginBottom: '0.5rem' }}>Win Rate</div>
              <div style={{ fontSize: '2.5rem', fontWeight: '800' }}>{overview.win_rate}%</div>
            </div>
            <div>
              <div style={{ fontSize: '0.875rem', opacity: 0.9, marginBottom: '0.5rem' }}>Total Wins</div>
              <div style={{ fontSize: '2.5rem', fontWeight: '800', color: '#86efac' }}>{overview.total_wins}</div>
            </div>
            <div>
              <div style={{ fontSize: '0.875rem', opacity: 0.9, marginBottom: '0.5rem' }}>Total Losses</div>
              <div style={{ fontSize: '2.5rem', fontWeight: '800', color: '#fca5a5' }}>{overview.total_losses}</div>
            </div>
            <div>
              <div style={{ fontSize: '0.875rem', opacity: 0.9, marginBottom: '0.5rem' }}>Net Profit</div>
              <div style={{ fontSize: '2.5rem', fontWeight: '800', color: overview.net_profit >= 0 ? '#86efac' : '#fca5a5' }}>
                {overview.net_profit >= 0 ? '+' : ''}${overview.net_profit}
              </div>
            </div>
          </div>
        </div>

        {/* Avg Profit Reached Comparison */}
        <div style={{ background: '#f8fafc', padding: '1.5rem', borderRadius: '12px', marginBottom: '2rem' }}>
          <h3 style={{ fontSize: '1.25rem', color: '#0c4a6e', marginBottom: '1rem', fontWeight: '700' }}>
            📈 Average % of TP Reached
          </h3>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1.5rem' }}>
            <div style={{ background: '#dcfce7', padding: '1.5rem', borderRadius: '8px', border: '2px solid #86efac' }}>
              <div style={{ fontSize: '0.875rem', color: '#166534', marginBottom: '0.5rem', fontWeight: '600' }}>✅ Wins</div>
              <div style={{ fontSize: '2rem', fontWeight: '700', color: '#166534' }}>{overview.avg_win_profit_reached}%</div>
              <div style={{ fontSize: '0.75rem', color: '#166534', marginTop: '0.5rem' }}>Average TP progress before closing</div>
            </div>
            <div style={{ background: '#fee2e2', padding: '1.5rem', borderRadius: '8px', border: '2px solid #fca5a5' }}>
              <div style={{ fontSize: '0.875rem', color: '#991b1b', marginBottom: '0.5rem', fontWeight: '600' }}>❌ Losses</div>
              <div style={{ fontSize: '2rem', fontWeight: '700', color: '#991b1b' }}>{overview.avg_loss_profit_reached}%</div>
              <div style={{ fontSize: '0.75rem', color: '#991b1b', marginTop: '0.5rem' }}>Average TP progress before reversing</div>
            </div>
          </div>
        </div>

        {/* Performance by Pair */}
        <div style={{ background: '#f8fafc', padding: '1.5rem', borderRadius: '12px', marginBottom: '2rem' }}>
          <h3 style={{ fontSize: '1.25rem', color: '#0c4a6e', marginBottom: '1rem', fontWeight: '700' }}>
            🌍 Performance by Pair
          </h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
            {comparisonStats.pair_performance?.slice(0, 10).map((pair, idx) => (
              <div
                key={idx}
                style={{
                  background: 'white',
                  padding: '1rem',
                  borderRadius: '8px',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  border: '1px solid #e2e8f0'
                }}
              >
                <div>
                  <div style={{ fontSize: '1rem', fontWeight: '700', color: '#0f172a' }}>{pair.pair}</div>
                  <div style={{ fontSize: '0.75rem', color: '#64748b', marginTop: '0.25rem' }}>
                    {pair.wins}W - {pair.losses}L | Profit: ${pair.total_profit.toFixed(2)}
                  </div>
                </div>
                <div style={{
                  padding: '0.5rem 1rem',
                  background: pair.win_rate >= 70 ? '#dcfce7' : pair.win_rate >= 50 ? '#fef3c7' : '#fee2e2',
                  color: pair.win_rate >= 70 ? '#166534' : pair.win_rate >= 50 ? '#92400e' : '#991b1b',
                  borderRadius: '6px',
                  fontWeight: '700',
                  fontSize: '0.875rem'
                }}>
                  {pair.win_rate}%
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Performance by Probability Tier */}
        <div style={{ background: '#f8fafc', padding: '1.5rem', borderRadius: '12px' }}>
          <h3 style={{ fontSize: '1.25rem', color: '#0c4a6e', marginBottom: '1rem', fontWeight: '700' }}>
            🎯 Performance by Probability Tier
          </h3>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '1rem' }}>
            {comparisonStats.tier_performance?.map((tier, idx) => (
              <div
                key={idx}
                style={{
                  background: 'white',
                  padding: '1.25rem',
                  borderRadius: '8px',
                  border: '2px solid #e2e8f0'
                }}
              >
                <div style={{ fontSize: '1rem', fontWeight: '700', color: '#0c4a6e', marginBottom: '0.75rem' }}>
                  {tier.tier}% Probability
                </div>
                <div style={{ fontSize: '2rem', fontWeight: '800', color: tier.win_rate >= 70 ? '#10b981' : tier.win_rate >= 50 ? '#f59e0b' : '#ef4444', marginBottom: '0.5rem' }}>
                  {tier.win_rate}%
                </div>
                <div style={{ fontSize: '0.875rem', color: '#64748b' }}>
                  {tier.wins} wins | {tier.losses} losses
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default WinLossAnalysisContent;
